import React, { useEffect, useMemo, useState } from "react";
import { StyledTablePage } from "../../styled-components/StyledTablePage.style";
import Flex from '@react-css/flex';
import Modal from 'react-modal';
import { StyledForm } from "../../styled-components/StyledForm.style";
import api from '../../services/api';

export const ModalTimeSheetHistorico = ({ idTimesheet, isOpen, onAfterOpen, onRequestClose }) => {
    const [historicos, setHistoricos] = useState([]);
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Credentials': false
        }
    }

    const style = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: "0px",
            minWidth: '35%',
            overflowY: 'auto',
            minHeight: '45%',
            maxHeight: '90%',
            maxWidth: '100%'
        },
        overlay: {
            zIndex: 9999
        }
    };

    const colunas = useMemo(() => [{
        columns: [
            {
                Header: "Data do registro"
            },
            {
                Header: "Executado por"
            },
            {
                Header: "Etapa"
            },
            {
                Header: "Status"
            },
            {
                Header: "Mensagem"
            }]
    }],
        []);

    useEffect(() => {
        const asyncFn = async () => {
            setHistoricos([])
            if (idTimesheet) {
                try {
                    const response = await api.get(`timesheet/${idTimesheet}/historico`, config);
                    setHistoricos(response.data.data);
                } catch (err) { }
            }
        }
        asyncFn();

    }, [idTimesheet])

    return (
        <Modal
            isOpen={isOpen}
            onAfterOpen={onAfterOpen}
            onRequestClose={onRequestClose}
            contentLabel="Histórico"
            style={style}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={false}
        >
            <StyledForm>
                <p className="modal-close" onClick={onRequestClose}>X</p>
            </StyledForm>
            <Flex>
                <StyledForm style={{ width: "100%" }}>
                    <Flex>
                        <Flex.Item className="modal-width">
                            <div className="position-relative form-group">
                                <p className="modal-title">Histórico Aprovações</p>
                            </div>
                        </Flex.Item>
                    </Flex>
                    <StyledTablePage>
                        <div className="table-scroll">
                            <table className="table table-bordered table-width">
                                <thead>
                                    <tr className="table-legend-info">
                                        {colunas[0].columns.map(column => (
                                            <th key={column.Header}>{column.Header}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {historicos?.map((historico, index) => (
                                        <tr key={historico.idTimesheetItemAtividadeLog} className={`${index == 0 ? 'primeiro-ativo' : ''} ${historico.status == "Reprovado" ? 'primeiro-reprovado' : ''}`}>
                                            <td className="text-center">{historico.dataCriacao}</td>
                                            <td className="text-center">{historico.nomeUsuario}</td>
                                            <td className="text-center">{historico.mensagem == 'TS Finalizado' ? '' : historico.nomeEtapa }</td>
                                            <td className="text-center">{historico.mensagem == 'TS Finalizado' ? '' : historico.status }</td>
                                            <td className="text-center">{historico.mensagem}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </StyledTablePage>
                </StyledForm>
            </Flex>
        </Modal>
    );
};